import { render, staticRenderFns } from "./EditNonTransferable.vue?vue&type=template&id=f1c35fd8&"
import script from "./EditNonTransferable.vue?vue&type=script&lang=ts&"
export * from "./EditNonTransferable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports